import {
  HTTP_STATUS_PAYMENT_REQUIRED,
  HTTP_STATUS_TOO_MANY_REQUESTS,
  HTTP_STATUS_UNAVAILABLE,
} from '../../constants/api'
import { FORMIK_EMPTY_VALUE } from '../../constants/validation'

import LongLengthIcon from '../../icons/text-long.svg'
import MediumLengthIcon from '../../icons/text-medium.svg'
import ShortLengthIcon from '../../icons/text-short.svg'

export const AITextGenerationType = {
  Email: 'email',
  Post: 'post',
}

export const AITextGenerationLocalContextType = {
  ActivityEmail: 'activity_email',
  EmailReply: 'email_reply',
  ServiceRequestEmail: 'service_request_email',
}

export const QA_NAME_AI_TEXT_GENERATION = 'ai_text_generation'

export const QA_NAME_AI_TEXT_GENERATION_INPUT = 'input'

export const QA_NAME_AI_TEXT_GENERATION_GENERATE_BUTTON = 'generate_button'

export const QA_NAME_AI_TEXT_GENERATION_STOP_BUTTON = 'stop_button'

export const QA_NAME_AI_TEXT_GENERATION_TEMPLATES_SELECT = 'templates_select'

export const QA_NAME_AI_TEXT_GENERATION_TONE_SELECT = 'tone_select'

export const QA_NAME_AI_TEXT_GENERATION_LENGTH_SELECT = 'length_select'

export const QA_NAME_AI_TEXT_GENERATION_REMOVE_NOTICE_CHECKBOX =
  'remove_notice_checkbox'

export const AI_PROMPT_MAX_LENGTH = 2000

export const AI_TEXT_GENERATION_FORM_FIELD_NAME_PROMPT = 'prompt'

export const AI_TEXT_GENERATION_FORM_FIELD_NAME_TEMPLATE = 'template'

export const AI_TEXT_GENERATION_FORM_FIELD_NAME_TONE = 'tone'

export const AI_TEXT_GENERATION_FORM_FIELD_NAME_LENGTH = 'length'

export const AI_TEXT_GENERATION_FORM_FIELD_NAME_REMOVE_NOTICE = 'removeNotice'

export const AI_TEXT_GENERATION_FORM_INITIAL_VALUES = {
  [AI_TEXT_GENERATION_FORM_FIELD_NAME_LENGTH]: null,
  [AI_TEXT_GENERATION_FORM_FIELD_NAME_PROMPT]: FORMIK_EMPTY_VALUE,
  [AI_TEXT_GENERATION_FORM_FIELD_NAME_REMOVE_NOTICE]: true,
  [AI_TEXT_GENERATION_FORM_FIELD_NAME_TEMPLATE]: null,
  [AI_TEXT_GENERATION_FORM_FIELD_NAME_TONE]: null,
}

export const AI_TONE_OPTIONS = [
  { labelKey: 'AITextGeneration.ToneFormalKey', value: 'formal' },
  { labelKey: 'AITextGeneration.ToneInformalKey', value: 'informal' },
  { labelKey: 'AITextGeneration.ToneFriendlyKey', value: 'friendly' },
  { labelKey: 'AITextGeneration.ToneProfessionalKey', value: 'professional' },
  { labelKey: 'AITextGeneration.ToneApologeticKey', value: 'apologetic' },
  { labelKey: 'AITextGeneration.TonePersuasiveKey', value: 'persuasive' },
]

export const AI_LENGTH_OPTIONS = [
  {
    Icon: ShortLengthIcon,
    labelKey: 'AITextGeneration.LengthShortKey',
    value: 'short',
  },
  {
    Icon: MediumLengthIcon,
    labelKey: 'AITextGeneration.LengthMediumKey',
    value: 'medium',
  },
  {
    Icon: LongLengthIcon,
    labelKey: 'AITextGeneration.LengthLongKey',
    value: 'long',
  },
]

export const AI_TEXT_GENERATION_SERVER_ERROR_PROMPT_TOO_LONG =
  'Ensure_this_field_has_no_more_than_2000_characters'

export const AI_TEXT_GENERATION_SERVER_ERROR_NO_PERMISSION =
  'You_do_not_have_permission_to_perform_this_action'

export const AI_TEXT_GENERATION_SERVER_ERRORS = {
  [AI_TEXT_GENERATION_SERVER_ERROR_NO_PERMISSION]:
    'AITextGeneration.NoPermissionErrorKey',
  [AI_TEXT_GENERATION_SERVER_ERROR_PROMPT_TOO_LONG]:
    'AITextGeneration.PromptTooLongErrorKey',
}

export const AI_TEXT_GENERATION_SERVER_ERROR_STATUSES = {
  [HTTP_STATUS_PAYMENT_REQUIRED]: 'Error.AILimitReachedErrorKey',
  [HTTP_STATUS_TOO_MANY_REQUESTS]: 'AITextGeneration.RateLimitErrorKey',
  [HTTP_STATUS_UNAVAILABLE]: 'AITextGeneration.AIServiceUnavailableErrorKey',
}

export const AI_TEXT_GENERATION_ADAPTIVE_SCREEN_BREAKPOINTS = {
  401: 401,
  501: 501,
}

export const AI_TEXT_GENERATION_VOICE_PLACEHOLDER_KEYS = {
  Connecting: 'AITextGeneration.VoiceConnectingPlaceholderKey',
  Ready: 'AITextGeneration.VoiceReadyHintKey',
  ReadyClosing: 'AITextGeneration.VoiceReadyHintClosingKey',
  ReadyTapToRestart: 'AITextGeneration.VoiceReadyHintTapToRestartKey',
  ReadyWaiting: 'AITextGeneration.VoiceReadyHintWaitingKey',
}

export const AI_VOICE_INPUT_ERROR = {
  NoMicrophoneAccess: 'noMicrophoneAccess',
  OutOfTokens: 'outOfTokens',
  ServiceError: 'serviceError',
}

export const AI_VOICE_INPUT_ERRORS = {
  [AI_VOICE_INPUT_ERROR.NoMicrophoneAccess]:
    'AITextGeneration.VoiceErrorNoMicrophoneKey',
  [AI_VOICE_INPUT_ERROR.OutOfTokens]:
    'AITextGeneration.VoiceErrorOutOfTokensKey',
  [AI_VOICE_INPUT_ERROR.ServiceError]: 'AITextGeneration.VoiceErrorServiceKey',
}

export const AI_VOICE_INPUT_HINT_TIMINGS_MS = {
  AutoClose: 10000,
  Closing: 9000,
  TapToRestart: 6000,
  Waiting: 3000,
}

export const AI_VOICE_INPUT_HINT_PLACEHOLDER_STEPS = [
  {
    delay: AI_VOICE_INPUT_HINT_TIMINGS_MS.Waiting,
    placeholderKey: AI_TEXT_GENERATION_VOICE_PLACEHOLDER_KEYS.ReadyWaiting,
  },
  {
    delay: AI_VOICE_INPUT_HINT_TIMINGS_MS.TapToRestart,
    placeholderKey: AI_TEXT_GENERATION_VOICE_PLACEHOLDER_KEYS.ReadyTapToRestart,
  },
  {
    delay: AI_VOICE_INPUT_HINT_TIMINGS_MS.Closing,
    placeholderKey: AI_TEXT_GENERATION_VOICE_PLACEHOLDER_KEYS.ReadyClosing,
  },
]

export const AI_VOICE_INPUT_RECORDING_SILENCE_TIMEOUT_MS = 10000
